import React from 'react';
import { useSelector } from 'react-redux';
import { isSelectedTicketReviewTicket } from 'extractFromState';
import { isLiveChat, isAsyncChat, isDelayedAsyncChat, isVoiceCallChat } from '../../util/chat';
import { isAnswered } from 'selectors/tickets';
import { validCommunicationType } from 'constants/conversationTypes';

export default function TicketIcon({ ticket }) {
  const isReviewTicket = useSelector(isSelectedTicketReviewTicket);
  const isSelected = useSelector((state) => state.selectedTicketId === ticket.ticketId);

  // eslint-disable-next-line jsx-a11y/alt-text
  return <img {...getIconAttrs()} />;

  function getIconAttrs() {
    if (isReviewTicket) {
      return {
        src: '/images/conversationIcons/review-ticket-icon.svg',
        alt: 'review ticket',
      };
    }

    if (isDelayedAsyncChat(ticket)) {
      return {
        src: '/images/conversationIcons/delayed-async-chat-or-sms.svg',
        alt: 'delayed async-chat',
      };
    }

    if (isAsyncChat(ticket)) {
      return {
        src: '/images/conversationIcons/realtime-async-chat-or-sms.svg',
        alt: 'realtime async-chat',
      };
    }

    if (isVoiceCallChat(ticket) && !isSelected) {
      return {
        src: '/images/conversationIcons/voice-call-icon.svg',
        alt: 'realtime voice call chat',
      };
    }

    if (isSelected) {
      if (isVoiceCallChat(ticket)) {
        return {
          src: '/images/conversationIcons/selected-voice-call-icon.svg',
          alt: 'selected voice call chat',
        };
      }

      if (isLiveChat(ticket.communicationType)) {
        return {
          src: '/images/conversationIcons/selected-chat-icon.svg',
          alt: 'selected chat',
        };
      }

      return {
        src: '/images/conversationIcons/selected-email-icon.svg',
        alt: 'selected email',
      };
    }

    if (!isAnswered(ticket)) {
      if (isLiveChat(ticket.communicationType)) {
        return {
          src: '/images/conversationIcons/unanswered-chat-icon.svg',
          alt: 'unanswered chat',
        };
      }

      if (ticket.communicationType === validCommunicationType.TWITTER_DM) {
        return {
          src: '/images/conversationIcons/unanswered-twitter-icon.svg',
          alt: 'unanswered twitter',
        };
      }

      return {
        src: '/images/conversationIcons/unanswered-unselected-email-icon.svg',
        alt: 'unanswered unselected email',
      };
    }

    if (isVoiceCallChat(ticket) && !isSelected) {
      return {
        src: '/images/conversationIcons/answered-voice-call-icon.svg',
        alt: 'answered voice call chat',
      };
    }

    if (isLiveChat(ticket.communicationType)) {
      return {
        src: '/images/conversationIcons/answered-chat-icon.svg',
        alt: 'answered chat',
      };
    }

    if (ticket.communicationType === validCommunicationType.TWITTER_DM) {
      return {
        src: '/images/conversationIcons/answered-twitter-icon.svg',
        alt: 'answered twitter',
      };
    }

    return {
      src: '/images/conversationIcons/answered-email-icon.svg',
      alt: 'answered email',
    };
  }
}
